










































Vue.use require('element-ui/lib/autocomplete').default

module.exports =
  name: 'transaction_current_popover_category'
  props: ['transaction']
  data: ->
    category_modal_visible: false
    display_all_categories: true
  computed:
    filtered_categories: ->
      if @display_all_categories || !@transaction.category
        return @queryCategories('')
      else
        return @queryCategories(@transaction.category)
  methods:
    onInput: ($event) ->
      #
      @transaction.category = $event.target.value
      @display_all_categories = false
    openCategoryModal: ->
      @category_modal_visible = true
      @display_all_categories = true
      @$nextTick ->
        $('input[name=category]').focus()
    selectCategory: (category) ->
      @transaction.category = category
      @category_modal_visible = false
    queryCategories: (queryString, cb) ->
      queryString ||= ''
      queryString = queryString.toLowerCase()
      replacer1 = { 'q':'й', 'w':'ц', 'e':'у', 'r':'к', 't':'е', 'y':'н', 'u':'г', 'i':'ш', 'o':'щ', 'p':'з', '[':'х', ']':'ъ', 'a':'ф', 's':'ы', 'd':'в', 'f':'а', 'g':'п', 'h':'р', 'j':'о', 'k':'л', 'l':'д', ';':'ж', "'":'э', 'z':'я', 'x':'ч', 'c':'с', 'v':'м', 'b':'и', 'n':'т', 'm':'ь', ',':'б', '.':'ю', '/':'.' }
      replacer2 = { 'й':'q', 'ц':'w', 'у':'e', 'к':'r', 'е':'t', 'н':'y', 'г':'u', 'ш':'i', 'щ':'o', 'з':'p', 'х':'[', 'ъ':']', 'ф':'a', 'ы':'s', 'в':'d', 'а':'f', 'п':'g', 'р':'h', 'о':'j', 'л':'k', 'д':'l', 'ж':';', 'э':"'", 'я':'z', 'ч':'x', 'с':'c', 'м':'v', 'и':'b', 'т':'n', 'ь':'m', 'б':',', 'ю':'.', '.':'/' }
      replaced_query_string1 = (_.map queryString, (letter) -> replacer1[letter]  || letter).join('')
      replaced_query_string2 = (_.map queryString, (letter) -> replacer2[letter]  || letter).join('')
      res = @$store.getters.not_hidden_transactions_categories.filter (cat) ->
        cat_name = cat.name.toLowerCase()
        as_is_condition = cat_name.includes(queryString)
        return true if as_is_condition == true
        replaced_condition1 = cat_name.includes(replaced_query_string1)
        return true if replaced_condition1 == true
        replaced_condition2 = cat_name.includes(replaced_query_string2)
        return true if replaced_condition2 == true
        return false
      result = _.map res, (category) ->
        count = category.count
        category = category.name
        {
          value: category
          label: category
        }
      if cb
        cb(result)
      else
        return result
